export default "__VITE_ASSET__DWdTqzL5__"